const KEY_HEX = import.meta.env.VITE_SCRAPE_PROTECTION_KEY;
let _keyPromise = null;

function _importKey() {
  if (_keyPromise) return _keyPromise;
  const bytes = new Uint8Array(KEY_HEX.match(/.{2}/g).map(b => parseInt(b, 16)));
  _keyPromise = crypto.subtle.importKey('raw', bytes, 'AES-GCM', false, ['decrypt']);
  return _keyPromise;
}

/**
 * Decrypt an AES-256-GCM encrypted response envelope.
 *
 * Expected format: { d: "<base64(ciphertext+tag)>", iv: "<base64(iv)>" }
 *
 * If the response is not encrypted (no `.d` field), it is returned as-is —
 * this happens when VITE_SCRAPE_PROTECTION_KEY is not set on the backend.
 *
 * @param {Object} data - Parsed JSON response from the API
 * @returns {Promise<Object>} Decrypted response object
 */
export async function decryptResponse(data) {
  if (!data?.d) return data;
  const key = await _importKey();
  const iv = Uint8Array.from(atob(data.iv), c => c.charCodeAt(0));
  const ct = Uint8Array.from(atob(data.d), c => c.charCodeAt(0));
  const buf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ct);
  return JSON.parse(new TextDecoder().decode(buf));
}
